export const UserRole = Object.freeze({
    // user types for Guest Operations group
    GUEST_OPERATIONS_ADMIN: 'core_team',
    GUEST_OPERATIONS_FPO: 'fpo',
    GUEST_OPERATIONS_SUPPORT_STAFF: 'support_staff',
    GUEST_OPERATIONS_FULL_VIEW: 'full_view',
    GUEST_OPERATIONS_RESTRICTED_VIEW: 'restricted_view',
    GUEST_OPERATIONS_SEATING_VIEW_ONLY: 'seating_view_only',
} as const);
